import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { switchLanguage } from '../../../../../actions/userAccount/user/switchLanguage'
import { CountryCode } from '../../../../../i18n/countryCodes'
import { IStore } from '../../../../../reducers'
import { getSelectedLanguage } from '../../../../../reducers/userAccount/selectors/userLanguage'
import { ILanguageMenu, ILanguageMenuDispatch } from './LanguageMenu'

function mapStateToProps(state: IStore): ILanguageMenu {
  return {
    countryCode: getSelectedLanguage(state),
  }
}

function bindDispatchToProps(dispatch: Dispatch): ILanguageMenuDispatch {
  return {
    switchLanguage(countryCode: CountryCode) {
      dispatch(switchLanguage(countryCode))
    },
  }
}

export default connect<ILanguageMenu, ILanguageMenuDispatch>(
  mapStateToProps,
  bindDispatchToProps,
)
